import {i18n} from '@/plugins/i18n'
import {customerStatusVariant, customerStatusStr} from "@/constants/customerStatus";


export default [
    {
        field: 'id',
        title: i18n.t('online-factor.hash_id'),
        sortable: false,
        width: 50,
        textAlign: 'center',
    },
    {
        field: 'title',
        title: i18n.t('online-factor.title_factor'),
        sortable: false,
        width: 100,
        textAlign: 'center',
    },
    {
        field: 'code',
        title: i18n.t('online-factor.code_factor'),
        template: (row) => {
            if (row.code !== null) {
                return '<span dir="ltr">' + row.code + '</span>'
            }else{
                return '<span dir="ltr">___</span>'
            }
        },
        sortable: false,
        textAlign: 'center',
        width: 80,
    },
    {
        field: 'sent_date',
        title: i18n.t('online-factor.send_date_factor'),
        template: (row) => '<span dir="ltr">'+row.sent_date+'</span>',
        sortable: true,
        textAlign: 'center',
        width: 80,
    },
    {
        field: 'creator_factor',
        title: i18n.t('online-factor.factor_creator'),
        template: (row) => {
                if(row.is_admin){
                    return '<a href="/users/'+row.user.id+'/details"><span dir="ltr">'+ row.user.full_name +'</span></a>'
                }else{
                    return '<span dir="ltr">'+ row.user.full_name +'</span>'
                }
        },
        sortable: false,
        textAlign: 'center',
        width: 100,
    },
    {
        field: 'customers_id',
        title: i18n.t('online-factor.customer'),
        template: (row) => {
            if (!row.customer) {
                return '<span dir="ltr">-</span>'
            }

            if (row.is_admin) {
                if (row.customer.name !== null) {
                    return '<a href="/customers/' + row.customer.id + '/details"><span class="text-success" dir="ltr">' + row.customer.name + '</span></a>'
                } else if (row.customer.email !== null) {
                    return '<a href="/customers/' + row.customer.id + '/details"><span class="text-success" dir="ltr">' + row.customer.email + '</span></a>'
                } else {
                    return '<a href="/customers/' + row.customer.id + '/details"><span class="text-success" dir="ltr">' + row.customer.mobile + '</span></a>'
                }
            } else {
                return '<span dir="ltr">' + row.user.full_name + '</span>'
            }
        },
        sortable: false,
        textAlign: 'center',
        width: 80,
    },
    {
        field: 'format_name',
        title: i18n.t('online-factor.format'),
        template: (row) => {
            if (row.is_admin) {
                if (row.format !== null) {
                    return '<a href="/customer-formats/' + row.format.id + '/details"><span class="text-success" dir="ltr">' + row.format.name + '</span></a>'
                }
                return '<span dir="ltr">-</span>'
            } else {
                return '<span dir="ltr">' + (row.format ? row.format.name : '-') + '</span>'
            }
        },
        sortable: false,
        textAlign: 'center',
        width: 100,
    },
    {
        field: 'is_archived',
        title: i18n.t('label.status'),
        template: (row) => {
            let status = customerStatusStr.get(row.is_archived)
            let variant = 'badge-' + customerStatusVariant(row.is_archived)

            return '<div class="badge ' + variant + ' text-white">' + status + '</div>'
        },
        sortable: false,
        textAlign: 'center',
        width: 80,
    },
    {
        field: 'payment_amount',
        title: i18n.t('online-factor.pay_amount'),
        template: (row) => {
            return `<div>${row.payment_amount} ریال</div>`
        },
        sortable: false,
        textAlign: 'center',
        width: 100,
    }
]
export const image_status = (row) => {
    if(row.image == null) {
        return '<div>'+i18n.t('online-factor.without_picture')+'</div>'
    }
    else
        return '<img src="'+row.image+'" width="60"/>'
}
